import { useMemo } from 'react';
import PropTypes from 'prop-types';
// styles
import styled from 'styled-components';
// logic
import { useTranslation } from 'react-i18next';
import {
  formatters as loadFormatters,
  constants as loadConstants,
} from 'utils/loads';
import { isNumberPositive } from 'utils/numbers';

import { constants as dateAndTimeConstants } from 'utils/dateAndTimes';

const LoadsSummaryInline = ({ className, loads, stopType = '' }) => {
  const { t } = useTranslation('loads');

  const content = useMemo(() => {
    const loadsToShow = loads.filter((l) =>
      isNumberPositive(l[loadConstants.FIELDS.NUMBER_OF_ITEMS])
    );

    if (loadsToShow.length === 0) {
      return '';
    }

    const totalNumberOfPallets = loadsToShow.reduce(
      (acc, l) => acc + parseInt(l[loadConstants.FIELDS.NUMBER_OF_ITEMS], 10),
      0
    );

    const formatter = {
      [dateAndTimeConstants.STOP_TYPES.PICKUP]: 'loading_number_of_pallets',
      [dateAndTimeConstants.STOP_TYPES.DROPOFF]: 'unloading_number_of_pallets',
    };

    return t(
      formatter[stopType.toUpperCase()] || 'shipping_number_of_pallets',
      {
        count: totalNumberOfPallets,
        grouped_number_of_pallets:
          loadFormatters.getGroupedNumberPalletsFormatted({
            loads,
            t,
          }),
      }
    );
  }, [t, loads, stopType]);

  return <div className={className}>{content}</div>;
};

LoadsSummaryInline.propTypes = {
  className: PropTypes.string,
  loads: PropTypes.arrayOf(PropTypes.object).isRequired,
  stopType: PropTypes.string,
};

export default styled(LoadsSummaryInline)`
  margin-top: 16px;
  color: var(--grey700);
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  height: 24px;
`;
